import { useTranslation } from 'react-i18next'
import ArtisticStyle from './ArtisticStyle'
import { CHOOSE_AN_ARTISTIC_STYLE_FOR_YOUR_IMAGE } from './translation/resources'
import cinematic from './assets/thumbnails/cinematic.png'
import anime from './assets/thumbnails/anime.png'
import manga from './assets/thumbnails/manga.png'
import pixelArt from './assets/thumbnails/pixel-art.png'
import fantasy from './assets/thumbnails/fantasy.png'
import neonpunk from './assets/thumbnails/neonpunk.png'
import paperCut from './assets/thumbnails/paper-cut.png'
import watercolor from './assets/thumbnails/watercolor.png'
import comic from './assets/thumbnails/comic.png'
import pencilSketch from './assets/thumbnails/pencil-sketch.png'
import chinesePainting from './assets/thumbnails/chinese-painting.png'
import japaneseUkiyoE from './assets/thumbnails/japanese-ukiyo-e.png'
import './ArtisticStyles.css'

const artisticStyles = [
  { name: 'Cinematic', image: cinematic },
  { name: 'Anime', image: anime },
  { name: 'Manga', image: manga },
  { name: 'Pixel Art', image: pixelArt },
  { name: 'Fantasy', image: fantasy },
  { name: 'Neonpunk', image: neonpunk },
  { name: 'Paper Cut', image: paperCut },
  { name: 'Watercolor', image: watercolor },
  { name: 'Comic', image: comic },
  { name: 'Pencil Sketch', image: pencilSketch },
  { name: 'Chinese Painting', image: chinesePainting },
  { name: 'Japanese Ukiyo-E', image: japaneseUkiyoE },
]

const ArtisticStyles = ({ showImage = true }) => {
  const { t } = useTranslation()

  return (
    <div className={`ArtisticStyles ${!showImage ? 'no-image' : ''}`}>
      <p className="ArtisticStyles__title">
        {t(CHOOSE_AN_ARTISTIC_STYLE_FOR_YOUR_IMAGE)}
      </p>

      <div
        className={`ArtisticStyles__list ${!showImage ? 'no-image' : ''}`}
        role="group"
        aria-label="Artistic styles"
      >
        {artisticStyles.map(({ name, image }, index) => (
          <ArtisticStyle
            index={index}
            key={name}
            name={name}
            image={image}
            showImage={showImage}
          />
        ))}
      </div>
    </div>
  )
}

export default ArtisticStyles
